import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemRoutingModule } from './item-routing.module';
import { NewItemComponent } from './new-item/new-item.component';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material/app-material.module';
import { ListItemComponent } from './list-item/list-item.component';

@NgModule({
  imports: [
    CommonModule,
    ItemRoutingModule,
    AppMaterialModule,
    FormsModule
  ],
  declarations: [NewItemComponent, ListItemComponent]
})
export class ItemModule { }
